module.exports = __webpack_public_path__ + "static/media/bold.7a3f7ba9.eot";